import axios from 'axios';
import { getConfig } from '../../../config/apiConfig';

const getCoreSettings = async (allowCache) => {
  // Get auth header config
  const config = await getConfig();
  const url = `api/settingapi/GetSettingsForPreferenceScreen?allowCache=${allowCache}`;

  return axios
    .get(url, config)
    .then(async (resp) => {
      let response = {};
      if (resp.data) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => err.response);
};

export const saveSettingDefinition = async (settings) => {
  // Get auth header config
  const config = await getConfig();
  const url = `api/settingapi/SaveSettingsForPreferenceScreen`;
  return axios
    .post(url, settings, config)
    .then(async (resp) => {
      return resp.data;
    })
    .catch((err) => err.response);
};

export default getCoreSettings;
